import { useStore } from "../../../app/stores/store";
import HeaderWrapper from "../../header/HeaderWrapper";
import Breadcrumb from "../../../app/common/common-components/Breadcrumb";
import OfficesDealGrid from "./OfficeDealGrid";

export default function OfficeDealGridPage() {
  const {
    userStore: { userSession },
  } = useStore();

  document.title = "Base - Office Deal Usage";

  return (
    <>
      <div className="container-fluid">
        <Breadcrumb breadcrumbs={[{ text: "Home", path: "/" }, { text: "Settings", path: "/settings" }, { text: "Office Deal Usage" }]} />
        <div className="row">
          <div className="hidden-sm col-md-2"></div>
          <div id="content" className="col-sm-12 col-md-12">
            <OfficesDealGrid />
          </div>
          <div className="hidden-sm col-md-2"></div>
        </div>
      </div>
    </>
  );
}
